import { useQuery } from "@tanstack/react-query";
import { AdminOrderService } from "../services/adminOrderService";
import {
  DashboardRange,
  DEFAULT_RANGE,
  rangeKey,
  rangeToParams,
} from "../types/dashboardRange";

const useDailyStats = (range: DashboardRange = DEFAULT_RANGE) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['daily-stats', rangeKey(range)],
        queryFn: () => AdminOrderService.getDailyStats(rangeToParams(range)),
    });

    return { data, isLoading, error };
};

export default useDailyStats;
